import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from 'react-icons/md'
import * as AiIcons from 'react-icons/ai'
import * as BiIcons from 'react-icons/bi'
import * as BsIcons from 'react-icons/bs'
import * as FiIcons from 'react-icons/fi'
import * as HiIcons from 'react-icons/hi'
import * as Hi2Icons from 'react-icons/hi2'
import * as IoIcons from 'react-icons/io'
import * as Io5Icons from 'react-icons/io5'
import * as Fa6Icons from 'react-icons/fa6'
import * as RiIcons from 'react-icons/ri'
import * as TbIcons from 'react-icons/tb'
import * as PiIcons from 'react-icons/pi'
import * as LuIcons from 'react-icons/lu'
import * as DuoIcons from 'app/components/icons/duotone'
import { IconFromText } from 'app/components/icons'

// Combine all icon libraries
const iconLibraries = [
    { prefix: 'Fa', icons: FaIcons },
    { prefix: 'Md', icons: MdIcons },
    { prefix: 'Ai', icons: AiIcons },
    { prefix: 'Bi', icons: BiIcons },
    { prefix: 'Bs', icons: BsIcons },
    { prefix: 'Fi', icons: FiIcons },
    { prefix: 'Hi', icons: HiIcons },
    { prefix: 'Hi2', icons: Hi2Icons },
    { prefix: 'Io', icons: IoIcons },
    { prefix: 'Io5', icons: Io5Icons },
    { prefix: 'Ri', icons: RiIcons },
    { prefix: 'Fa6', icons: Fa6Icons },
    { prefix: 'Tb', icons: TbIcons },
    { prefix: 'Lu', icons: LuIcons },
    { prefix: 'Pi', icons: PiIcons },
    // Custom duotone icon set
    { prefix: 'Duo', icons: DuoIcons }
]

// Get all available icons
export const getAllIcons = () => {
    const combined: Array<{ name: string; component: React.ComponentType<any>; set: string }> = []

    iconLibraries.forEach(({ prefix, icons }) => {
        Object.entries(icons).forEach(([name, component]) => {
            if (typeof component === 'function') {
                combined.push({ name, component, set: prefix })
            }
        })
    })

    return combined
}

// Render icon by name
export const renderIcon = (iconName: string, className?: string, style?: React.CSSProperties): React.ReactNode => {
    if (!iconName) return null

    // Try each icon library
    for (const { icons } of iconLibraries) {
        const IconComponent = icons[iconName as keyof typeof icons] as React.ComponentType<any>
        if (IconComponent && typeof IconComponent === 'function') {
            return React.createElement(IconComponent, { className, style })
        }
    }

    // Fallback to IconFromText for predefined icons
    return <IconFromText text={iconName} />
}

// Check if icon exists
export const iconExists = (iconName: string): boolean => {
    if (!iconName) return false

    for (const { icons } of iconLibraries) {
        if (icons[iconName as keyof typeof icons]) {
            return true
        }
    }

    return false
}
